<template>
  <div>
    Yönleniyorsun..
  </div>
</template>

<script>
  import authService from "@/services/authService";

  export default {
    name: "logout",
    methods: {
      logout() {
        authService.logout()
        .then(() => {
          this.$store.dispatch('token', {token: null})
          this.$store.dispatch('loginIt', false)

          setTimeout(() => {
            this.$router.push({name: 'home'})
          }, 1000)
        })
      }
    },
    created() {
      this.logout()
    }
  }
</script>

<style scoped>

</style>